/** 未ログインの人を送るログイン画面の URL。戻り先(クエリ・ハッシュ込み)を `redirect` に載せる。 */
export const buildLoginPath = (target: string): string =>
  target === '/' ? '/login' : `/login?redirect=${encodeURIComponent(target)}`;
